import React, { useState } from "react";
import configData from "../../../config.json";

const BYDSealSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedColor, setSelectedColor] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1741686908572.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1713960091604.png`,
      text: "Atlantis Gray",
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1741686969487.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1713960150881.png`,
      text: "Cosmos Black",
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1741687034645.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1742443890285.png`,
      text: "Aurora White",
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1741687079351.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1741687140190.webp`,
      text: "Shark Gray",
    },
  ];

  const colors = ["#273651", "#1C1F22", "#C6CED9", "#57595B"];

  const changeSlide = (index) => {
    setCurrentSlide(index);
    setActiveIndex(index);
    setSelectedColor(index);
  };

  return (
    <>
      <br></br>
      <br></br>
      <section className="fluid colorSection">
        <div className="slider-container">
          <div className="slider">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`slide ${activeIndex === index ? "active" : ""}`}
                style={{ backgroundImage: `url(${slide.backgroundImage})` }}
              >
                <div className="text">{slide.text}</div>
                <img
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                  className="slide-image"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="input-container">
          {colors.map((color, index) => (
            <div
              key={index}
              className="color-button"
              style={{
                backgroundColor: color,
                border: index === selectedColor ? "2px solid black" : "none",
              }}
              onClick={() => changeSlide(index)}
            ></div>
          ))}
        </div>
      </section>
    </>
  );
};

export default BYDSealSlider;
